/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_Faq_A4Inputs */

const en_guide_json_schema_faq_a4 = /** @type {(inputs: Guide_Json_Schema_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Many tools infer a starting schema from a sample document, which you then refine by marking required fields and narrowing types. It is a fast way to get most of the way there.`)
};

const ko_guide_json_schema_faq_a4 = /** @type {(inputs: Guide_Json_Schema_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 많은 도구가 샘플 문서에서 시작 스키마를 추론해 주며, 이후 필수 필드를 표시하고 타입을 좁혀 다듬으면 됩니다. 대부분의 작업을 빠르게 끝내는 방법입니다.`)
};

const ja_guide_json_schema_faq_a4 = /** @type {(inputs: Guide_Json_Schema_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。多くのツールがサンプル文書から出発点となるスキーマを推論してくれます。あとは必須フィールドを示し、型を狭めて仕上げます。大部分を素早く済ませる方法です。`)
};

/**
* | output |
* | --- |
* | "Yes. Many tools infer a starting schema from a sample document, which you then refine by marking required fields and narrowing types. It is a fast way to get..." |
*
* @param {Guide_Json_Schema_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_faq_a4 = /** @type {((inputs?: Guide_Json_Schema_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_faq_a4(inputs)
	if (locale === "ko") return ko_guide_json_schema_faq_a4(inputs)
	return ja_guide_json_schema_faq_a4(inputs)
});